import { useEffect } from 'react';

const TawkToChat = () => {
  useEffect(() => {
    // Creating the script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://embed.tawk.to/675a888caf5bfec1dbdac992/1iesqapue';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    // Appending the script to the document
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

    // Cleanup on component unmount
    return () => {
      const tawkScript = document.querySelector(
        'script[src="https://embed.tawk.to/675a888caf5bfec1dbdac992/1iesqapue"]'
      );
      if (tawkScript) {
        tawkScript.remove();
      }
      window.Tawk_API = undefined;
    };
  }, []);

  return null; // This component does not render any UI
};

export default TawkToChat;
